import Component from '@bythepixel/component-loader';

export default class TabUnderline extends Component {
  static selector = '[comp-tab-underline]';

  #underlineEvent;
  #removeUnderlineEvent;
  #state = {
    underlinedElement: undefined,
  }

  constructor(...args) {
    super(...args);
    this.#underlineEvent = this.$container.dataset.underlineEvent;
    this.#removeUnderlineEvent = this.$container.dataset.removeUnderlineEvent;
    this.events();
  }

  addUnderline(element) {
    this.#state.underlinedElement = element || this.#state.underlinedElement;
    const compStyle = window.getComputedStyle(element);
    const padding = parseInt(compStyle.paddingLeft, 10) + parseInt(compStyle.paddingRight, 10);

    requestAnimationFrame(() => {
      Object.assign(this.$container.style, {
        left: `${element.offsetLeft + parseInt(compStyle.paddingLeft, 10)}px`,
        width: `${element.scrollWidth - padding}px`,
        bottom: `${0}px`,
        opacity: null,
      });
    });
  }

  removeUnderline() {
    requestAnimationFrame(() => {
      Object.assign(this.$container.style, {
        opacity: '0',
      });
    });
  }

  events() {
    if (this.#removeUnderlineEvent) {
      this.$subscribe(this.#removeUnderlineEvent, () => {
        requestAnimationFrame(() => this.removeUnderline());
      });
    }
    if (this.#underlineEvent) {
      this.$subscribe(this.#underlineEvent, ({ element }) => {
        requestAnimationFrame(() => this.addUnderline(element));
      });
    }

    window.addEventListener('resize', () => {
      requestAnimationFrame(() => {
        if (this.#state.underlinedElement) {
          this.addUnderline(this.#state.underlinedElement);
        }
      });
    });
  }
}
